import { render, staticRenderFns } from "./SimpleRegistrationForm.vue?vue&type=template&id=63df2391"
import script from "./SimpleRegistrationForm.vue?vue&type=script&lang=js"
export * from "./SimpleRegistrationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports